import Vue from 'vue';
import axios from 'axios';

const EventBus = new Vue({

    data: () => ({
        queueFrequency: 50,
        queues: {},
        queuesConsumed: {},
        queuesFrequencyMap: {
            'axios-queue': 100
        }
    }),

    methods: {

        queueItem(item, queueName) {
            if (!this.queues.hasOwnProperty(queueName)) {
                this.queues[queueName] = [];
            }
            this.queues[queueName].push(item);
            this.runQueue(queueName);
        },

        runQueue(queueName) {
            if (!this.queuesConsumed.hasOwnProperty(queueName)) {
                this.consumeQueue(queueName);
            }
        },

        consumeQueue(queueName, worker) {

            if (
                this.queues.hasOwnProperty(queueName) &&
                this.queues[queueName].length &&
                typeof worker === "boolean" &&
                worker
            ) {
                if (typeof this.queues[queueName][0] === "function") {
                    this.queues[queueName][0]();
                }
                this.queues[queueName].splice(0, 1);
            }

            if (
                this.queues.hasOwnProperty(queueName) &&
                this.queues[queueName].length
            ) {
                let frequency = this.queueFrequency;
                if (this.queuesFrequencyMap.hasOwnProperty(queueName)){
                    frequency = this.queuesFrequencyMap[queueName];
                }
                const component = this;
                this.queuesConsumed[queueName] = setTimeout(function () {
                    component.consumeQueue(queueName, true);
                }, frequency);
                return;
            }

            delete this.queuesConsumed[queueName];


        }
    }
});

Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus;
        }
    }
});

export default EventBus;
